import { render, staticRenderFns } from "./ProceduresList.vue?vue&type=template&id=76885741&"
import script from "./ProceduresList.vue?vue&type=script&lang=js&"
export * from "./ProceduresList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports